// extracted by mini-css-extract-plugin
module.exports = {"ripplesWrapper":"CostsSection-module--ripples-wrapper--2pdz-","ripples":"CostsSection-module--ripples--1h-Ky","section":"CostsSection-module--section--e3Iq9"};